import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { Container, Toast } from 'react-bootstrap';
import { Link, useHistory, useParams } from 'react-router-dom';
import BusinessDetailsApi from '../../../../Api/BusinessDetailsApi';
import SupplierProductApi from '../../../../Api/SupplierProductApi';
import { getApiHost, getResponseError, getUserDetailsCookie } from '../../../../Api/Utils/apiUtils';
import ErrorAlert from '../../../../Components/Form/ErrorAlert/ErrorAlert';
import Section from '../../../../Components/Section/Section';
import SimpleImageSlider from "react-simple-image-slider";
import './../../../../Components/Accounts/Supplier/SupplierExtendedDetails/singleproduct.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { createChatRoom } from '../../../../Api/Utils/chatUtils';
import EventApi from '../../../../Api/EventApi';
import SupplierPaymentApi from '../../../../Api/SupplierPaymentApi';
import ScaleLoader from "react-spinners/ScaleLoader";

const SingleProductComponent = () => {
    const history = useHistory()
    const {supplierID, productID} = useParams()
    const [errorMessage, seterrorMessage] = useState(null);
    const [products, setproducts] = useState(null);
    const [counter, setcounter] = useState(1);
    const [business, setbusiness] = useState(null);
    const [eventsinfo, seteventsinfo] = useState(null);
    const [buying, setbuying] = useState(false);
    const [orderConfirming, setorderConfirming] = useState(false);
    const [orderEventinfo, setorderEventinfo] = useState(null);
    const [successMessage, setsuccessMessage] = useState(null);
    const [isloading, setisloading] = useState(true)


    useEffect(() => {
        const loadProductDetails = async () => {
            const businessRespons = await BusinessDetailsApi.getBusinessDetails(parseInt(supplierID))
            const businessResponseApiError = getResponseError(businessRespons)
            if (businessResponseApiError) {
                seterrorMessage(businessResponseApiError)
            }else{
                const businessInfo = businessRespons.objectVal
                setbusiness(businessInfo)
                const businessID = businessInfo.id
                const productResponse = await SupplierProductApi.getProductDetails(businessID)
                const productResponseApiError = getResponseError(productResponse)
                if (productResponseApiError) {
                    seterrorMessage(productResponseApiError)
                    setisloading(false)
                }else{
                    const productsInfo = productResponse.objectVal
                    setproducts(productsInfo)
                    setisloading(false)
                }
            }
        }
        loadProductDetails()
        const loadEventlist = async () => {
            const user = getUserDetailsCookie()
            const response = await EventApi.getEvent(user.id)
            const responseApiError = getResponseError(response)
            if (responseApiError) {
                seterrorMessage(responseApiError)
            }else{
                const events = response.objectVal
                seteventsinfo(events)
            }
        }
        loadEventlist()
    }, [supplierID])

    const getExectProduct = () => {
        const prod = products && products.find(x => x.id === parseInt(productID))
        return prod
    }
    const  product =  getExectProduct()

    //get image list
    const getimagelist = (prod) => {
        const list = []
        prod.GetproductInfoImage.forEach(img => {
            list.push({url: `${getApiHost()}/${img.imageUrl}`})
        });
        if (list.length === prod.GetproductInfoImage.length) {
            return list
        }
    }
    const images = product && getimagelist(product)

    // increse or decrese
    function decrese() {
        if (counter !== 1) {
            setcounter(counter-1) 
        } 
    }
    function increse() {
        setcounter(counter+1) 
    }

    // create chatroom
    const messageWithTheCustomer = (businessdata) => {
        const userdata = getUserDetailsCookie()
        const setupMessage = {
            mBuyerImage: `${userdata.imageUrl}`,
            mBuyerName: `${userdata.firstName} ${userdata.lastName}`,
            mSupplierImage: businessdata.businessLogo && businessdata.businessLogo.imageUrl,
            mSupplierName: `${businessdata.businessName}`,
            mSupplierPlayerId: "",
            mBuyerPlayerId: ""
        }
        createChatRoom(userdata.id, businessdata.userId, setupMessage)
        const loc = {
            pathname: '/messages',
            state: { id: `` }
        }
        history.push(loc)
        history.replace(loc)
    }

    const eventInfoSetup = (event) => {
        setbuying(false)
        setorderConfirming(true)
        setorderEventinfo({
            eventId: event.id,
            address: event.address,
            date: event.eventDate
        })
    }

    const confirmOrder = async () => {
        const { eventId, address, date } = orderEventinfo
        const user = getUserDetailsCookie()
        const ordersetup = {
            userId: user.id,
            productId: product.id,
            eventId,
            type: product.productBuyType,
            purchaseQuantity: counter,
            time_day: "",
            address,
            deliverytype: product.productType,
            date,
        }
        const respons = await SupplierPaymentApi.placeOrderRequest(ordersetup)
        const responseApiError = getResponseError(respons)
        if (responseApiError) {
            seterrorMessage(responseApiError)
            setorderConfirming(false)
        }else{
            
            setorderConfirming(false)
            if (respons.success === "true") {
                setsuccessMessage("Product purchase successfully..!")
                setTimeout(() => {
                    setsuccessMessage(null)
                }, 4000);
            }
        }
    }

    return (
        <>
        {isloading ? 
        <div className="loading-section">
            <ScaleLoader color={'#591EC1'} loading={isloading} size={40} />
        </div>
        :
        <Section contStyle={{minHeight: "50vh", backgroundColor: "#fff", marginBottom: "80px"}}>
                {(product && images) &&
            <Container>
                {successMessage &&
                <Toast style={{backgroundColor: 'green', margin: "0 auto", padding:"7px", width: "500px", marginBottom:"15px", color: "#FFF", borderRadius: "5px"}}>{successMessage}</Toast>}
                <ErrorAlert>{errorMessage}</ErrorAlert>
                    <div className="single-product-container">
                        {orderConfirming? 
                        <div className="confirm-order">
                            <div className="order-info">
                                <h5>Confirm Order</h5>
                                <div className="content">
                                    <h6>{product.title}</h6>
                                    <h6>Price: ${product.price}</h6>
                                    <h6>Quantity: {counter}</h6>
                                    <h6>Totla Amount: ${product.price * counter}</h6>
                                </div>
                                <div className="buttons">
                                    <button onClick={() => setorderConfirming(false)}>Cancle</button>
                                    <button onClick={confirmOrder}>Place Order</button>
                                </div>
                            </div>
                        </div>
                        :buying ?
                        <div className='event-list'>
                            {eventsinfo.length > 0 ? 
                                <>
                                <h4>Select your Event</h4>
                                {
                                eventsinfo.map((event) => (
                                    <div onClick={() => eventInfoSetup(event)} className="each-event" key={event.id}>
                                        <h6>{event.eventName}</h6>
                                        <h6>${event.Budget}</h6>
                                        <h6>{event.eventDate}</h6>
                                    </div>
                                ))}
                                <button onClick={() => setbuying(false)}>Cancle</button>
                                </>
                            :
                                <h4>No event found</h4>
                            }
                        </div>    
                        :
                        <>
                        <div className="image-slider">
                            <SimpleImageSlider
                                height={420}
                                width={730}
                                images={images.length > 0 ? images : [{url: "/img/no_image.jpg"}]}
                                showBullets={true}
                                showNavs={true}
                            />
                        </div>
                        <div className="product-content">
                            <div className="heading">
                                <div className="title">
                                    <h3>{product.title}</h3>
                                </div>
                                <div className="price">
                                    <h4>${product.price}</h4>
                                </div>
                            </div>
                            <div className="quantity">
                                <div className="quantity-name">
                                    <h6>Quantity</h6>
                                </div>
                                <div className="counter">
                                    <span className='minus' onClick={decrese}>-</span>
                                    <input type="text" value={counter} onChange={(e) => setcounter(e.target.value)} />
                                    <span onClick={increse}>+</span>
                                </div>
                            </div>
                            <div className="description">
                                <h6>Description</h6>
                                <p>{product.description}</p>
                            </div>
                            <div className="button-group">
                                <button onClick={() => messageWithTheCustomer(business)} className='enquire'>Enquire</button>
                                <button onClick={() => setbuying(true)} className='buy'>Buy</button>
                            </div>
                        </div>
                        </>}
                    </div>
                    <div className="back-button">
                        <Link to={`/suppliers/${supplierID}`}>
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </Link>
                    </div>
            </Container>
                }
        </Section>}
        </>
    );
};

export default SingleProductComponent;
